import { Link } from "react-router-dom";
import { EvidenceChip } from "./EvidenceChip";
import { shortName } from "./useSciPreview";
import { METRIC } from "./OutcomeTile";

const ROWS = [
  ["Philosophy share", (c) => c.philosophy_share && { text: c.philosophy_share }],
  ["Award", (c) => c.award && { text: c.award }],
  ["Length", (c) => c.duration && { text: c.duration }],
  ["Typical offer", (c) => c.typical_offer && { text: c.typical_offer }],
  ["Admissions test", (c) => c.admissions_test && { text: c.admissions_test }],
  ["Teaching", (c) => c.first_teaching && { text: c.first_teaching.value, claim: c.first_teaching }],
  ["Assessment", (c) => c.first_assessment && { text: c.first_assessment.value, claim: c.first_assessment }],
  ["Study abroad", (c) => c.study_abroad && { text: c.study_abroad.value, claim: c.study_abroad }],
  ["Earliest earnings", (c) => c.outcomes[0] && { text: c.outcomes[0].value, note: `${METRIC[c.outcomes[0].field]}. ${c.outcomes[0].population}. ${c.outcomes[0].period || ""}`, claim: c.outcomes[0] }],
];

function Cell({ v, testId }) {
  if (!v) return <span data-testid={testId} className="text-xs italic text-stone-400">Not verified</span>;
  return (
    <div data-testid={testId} className="space-y-1">
      <p className="text-sm text-stone-800">{v.text.charAt(0).toUpperCase() + v.text.slice(1)}</p>
      {v.note && <p className="text-[11px] leading-snug text-stone-500">{v.note}</p>}
      {v.claim && <EvidenceChip claim={v.claim} subtle testId={`${testId}-source`} />}
    </div>
  );
}

// Side-by-side view of the four pilot courses; every cell is a verified claim or says "Not verified".
export function CompareTable({ courses }) {
  return (
    <div className="-mx-6 overflow-x-auto px-6 lg:mx-0 lg:px-0" data-testid="sci-compare-table">
      <table className="w-full min-w-[760px] border-separate border-spacing-0 text-left">
        <thead>
          <tr>
            <th className="w-36" />
            {courses.map((c) => (
              <th key={c.degree_id} className="border-b-2 border-[#002147] p-3 align-bottom">
                <Link to={`/preview/sci/courses/${c.degree_id}`} data-testid={`sci-compare-open-${c.degree_id}`} className="group block">
                  <span className="block font-mono text-[10px] uppercase tracking-wider text-stone-500">{shortName(c)} · {c.university?.country}</span>
                  <span className="block font-editorial text-lg text-stone-900 group-hover:underline">{c.title}</span>
                </Link>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map(([label, get]) => (
            <tr key={label}>
              <th className="border-b border-stone-200 py-3 pr-3 align-top font-mono text-[10px] font-normal uppercase tracking-wider text-stone-500">{label}</th>
              {courses.map((c) => (
                <td key={c.degree_id} className="border-b border-stone-200 p-3 align-top">
                  <Cell v={get(c)} testId={`sci-compare-${label.toLowerCase().replace(/\s+/g, "-")}-${c.degree_id}`} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
